<script setup>
// The devEco mark. Eight spokes off a centre, drawn rather than imported so it
// inherits nothing and cannot go missing behind a broken asset path.
const SPOKES = [
  [39.15, 18.63], [49.69, 29.78], [59.84, 39.5], [49.69, 49.22],
  [39.15, 60.37], [28.31, 49.22], [18.16, 39.5], [28.31, 29.78],
];
</script>

<template>
  <svg class="mark" viewBox="4 4 71 71" aria-hidden="true">
    <circle cx="39.29" cy="39.5" r="30.3" fill="none" stroke="#4db3a8" stroke-width="2.5" />
    <line
      v-for="([x, y], i) in SPOKES" :key="`l${i}`"
      x1="39.29" y1="39.5" :x2="x" :y2="y"
      stroke="#4db3a8" stroke-width="2" stroke-linecap="round"
    />
    <circle
      v-for="([x, y], i) in SPOKES" :key="`c${i}`"
      :cx="x" :cy="y" r="3.5" fill="#4db3a8" stroke="#1e3a3a" stroke-width="1.2"
    />
    <circle cx="39.29" cy="39.5" r="5" fill="#4db3a8" stroke="#1e3a3a" stroke-width="1.8" />
  </svg>
</template>
